import { styled } from '@mui/material/styles';
import { FilterAlt, FormatListBulleted, GridViewRounded } from "@mui/icons-material";
import { Button, Grid, Pagination, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import BgBox from "../../../components/BgBox";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { getAllCustByVfyStatus } from "../../../services/req_service";
import { FaSortAmountDownAlt, FaSortAmountDown } from 'react-icons/fa';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import QueryKey from '../../../QueryKey';
import { useQuery } from 'react-query';
import LoadingScreen from '../../../components/loadingScreen';
import SingleCustReqTable from '../../../components/SingleCustReqTable';
import SingleCustReqCard from '../../../components/SingleCustReqCard';
import { useAuthContext } from '../../../context/AuthContext';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import RecordCount from "../../../components/RecordCount";
import SearchTxtFieldClr from '../../../components/SearchTxtFieldClr';
import CustomDropDown from '../../../components/CustomDropDown';
import FilterMdl from './FilterMdl';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    // margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

function PenRjcCustReqListPage() {
  const { t } = useTranslation();
  const { setLastSeenObjFn } = useAuthContext();
  const limit = DEFAULT_PAGE_SIZE

  const ddArr = [
    { value: "invoice", label: t("bo.cusReqLstPg.dInvoice") },
    { value: "ewb", label: t("bo.cusReqLstPg.dEwb") },
    { value: "name", label: t("bo.cusReqLstPg.dCus") },
    { value: "reqId", label: t("bo.cusReqLstPg.dReqId") },
    { value: "mobile", label: t("bo.cusReqLstPg.dContact") },
    { value: "cnor", label: t("bo.cusReqLstPg.dCnor") },
    { value: "cnee", label: t("bo.cusReqLstPg.dCnee") },
    { value: "from", label: t("bo.cusReqLstPg.dFrom") },
    { value: "to", label: t("bo.cusReqLstPg.dTo") },
    { value: "fromto", label: t("bo.cusReqLstPg.dFromTo") },
    { value: "matType", label: t("bo.cusReqLstPg.dMat") }
  ];

  const [searchParams, setSearchParams] = useSearchParams();
  let reqStatus = searchParams.get("reqStatus") || "pending";
  const pgNo = parseInt(searchParams.get("pgNo") || "1");
  const order = searchParams.get("order") || "desc";
  const view = searchParams.get("view") || "list";
  const searchType = searchParams.get("st") || ddArr[0].value;
  const querySearchWord = searchParams.get("s") || "";
  const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
  const [searchKeyWord, setSearchKeyWord] = useState(searchWord);
  const [searchKeyType, setSearchKeyType] = useState(searchType);
  const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
  const [isFilterMdlOpen, setIsFilterMdlOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({ cnorNames: [], cneeNames: [], picLocations: [], delLocations: [], shipmtStatuses: [] });

  // Always keep it as an array
  reqStatus = reqStatus === "pending" 
    ? ["pending", "lrupdate"] 
    : [reqStatus];

  // const [pageNumber, setPageNumber] = useState(1);
  // const [view, setView] = useState('list');
  // const [order, setOrder] = useState('desc');

  const { isLoading, isError, error, data: custReqRow } = useQuery(
    [QueryKey.penAllCustReqs, limit, pgNo, order, reqStatus, isSrchBtnClick, filterObj],
    () => getAllCustByVfyStatus({
      limit, pageNumber: pgNo, order, reqStatus: reqStatus, searchKeyWord, searchType: searchKeyType,
      cnorNames: filterObj.cnorNames, cneeNames: filterObj.cneeNames,
      picLocations: filterObj.picLocations, delLocations: filterObj.delLocations,
      shipmtStatuses: filterObj.shipmtStatuses,
    }), {
    keepPreviousData: true
  });

  function handleFilterObj(obj) {
    setFilterObj((prev) => ({ ...prev, ...obj }));
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  let title = t("bo.custInfoPg.penCustReq");

  if (reqStatus) {
    if (reqStatus === "pending") {
      title = t("bo.custInfoPg.penCustReq");
    } else if (reqStatus === "rejected") {
      title = t("bo.custInfoPg.rjcCustReq");
    }
  }

  useEffect(() => {
    if (reqStatus === "pending") {
      setLastSeenObjFn('penReq');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  function onViewChange(e, v) {
    if (v == null)
      return

    setSearchParams(prev => {
      prev.set("view", 1)
      return prev
    }, { replace: true })
  }

  async function onOrderChange(e, or) {
    if (or == null)
      return

    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("order", or)
      return prev
    }, { replace: true })
  }


  const handlePageChange = async (event, value) => {
    setSearchParams(prev => {
      prev.set("pgNo", value)
      return prev
    }, { replace: true })
  };

  async function onSearchBtnClick(e) {
    setSearchKeyWord(searchWord);
    setSearchKeyType(searchType);
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      return prev
    }, { replace: true })
  }

  function onSearch(e) {
    setSearchWord(e.target.value)
    setSearchParams(prev => {
      prev.set("s", encodeURIComponent(e.target.value))
      return prev
    }, { replace: true })
  }

  function handleDDChange(e) {
    setSearchParams(prev => {
      prev.set("st", e.target.value)
      return prev
    }, { replace: true })
  }

  function handleOnClear(e) {
    setIsSrchBtnClick((prevVal) => ++prevVal)
    setSearchWord("");
    setSearchKeyWord("")
    setSearchParams(prev => {
      prev.set("pgNo", 1)
      prev.set("s", "")
      return prev
    }, { replace: true })
  }

  function getSrchTypeTxt() {
    let filteredObj = ddArr.filter((i) => i.value === searchType);
    return filteredObj[0]?.label || "";
  }




  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  if (isLoading)
    return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>

  return (
    <Box height={"100%"} width={"100%"}>
      <Stack direction={'row'} justifyContent='space-between' mb={1.5} >
        <Stack direction={'row'} alignItems={"center"} gap={0.5} mr={4}>
          <Typography variant='h5' sx={{ fontWeight: "bold" }}>{title} <RecordCount count={custReqRow?.totalLength} /></Typography>
        </Stack>
      </Stack>

      <BgBox height={"95%"} px={4} py={1}>
        <Stack direction={'row'} justifyContent="space-between" alignItems={"center"} mb={1.2} mt={0.4} px={2}>
          <StyledToggleButtonGroup color="primary" size="small" value={view} exclusive onChange={onViewChange} sx={{ mb: 0.5, height: 36 }}>
            <ToggleButton value='list'>
              <FormatListBulleted /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.cusReqLstPg.list")}</Typography>
            </ToggleButton>
            <ToggleButton value="center">
              <GridViewRounded /> <Typography sx={{ ml: 0.3, fontSize: 15 }}>{t("bo.cusReqLstPg.grid")}</Typography>
            </ToggleButton>
          </StyledToggleButtonGroup>

          <Stack direction={'row'} justifyContent="space-between" alignItems={"center"}>

            <SearchTxtFieldClr handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`${t("bo.cusReqLstPg.search")} ${getSrchTypeTxt()} .....`} />
            <CustomDropDown height={36} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={searchType} />
            <Button variant='outlined' sx={{ ml: 2, mb: 0.5, height: 36, }} startIcon={<FilterAlt />} onClick={() => setIsFilterMdlOpen(true)} >{t("bo.filterMdl.filter")}</Button>

            <StyledToggleButtonGroup color="primary" size="small" value={order} exclusive onChange={onOrderChange} sx={{ mb: 0.5, height: 36, mx: 3 }}>
              <ToggleButton value='desc'>
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDown /></Stack>
              </ToggleButton>
              <ToggleButton value="asc">
                <Stack sx={{ fontSize: 18, justifyContent: "center", alignItems: "center" }}>  <FaSortAmountDownAlt /></Stack>
              </ToggleButton>
            </StyledToggleButtonGroup>

          </Stack>
        </Stack>

        {view === 'list' ? <SingleCustReqTable custReqRow={custReqRow?.data} time={"current"} reqStatusType={reqStatus} /> :
          <ScrollBox height={"84%"}>
            <Grid container spacing={1}
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              {custReqRow?.data.map((i) => <Grid item xs="auto" key={i.id}> <SingleCustReqCard i={i} reqStatusType={reqStatus} /> </Grid>)}
            </Grid>
          </ScrollBox>
        }

        <Stack sx={{ alignItems: "center", mt: 1 }}>
          <Pagination count={Math.ceil(custReqRow?.totalLength / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
        </Stack>

        <FilterMdl modalOpen={isFilterMdlOpen} handleModalClose={() => setIsFilterMdlOpen(false)} filterObj={filterObj} handleFilterObj={handleFilterObj} />
      </BgBox>
    </Box>
  )
}

export default PenRjcCustReqListPage;